import { useEffect, useState } from 'react';
import { tokenApi, type TenantOption } from './api';

export const controlClass =
  'px-3 py-2 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg text-sm outline-none focus:border-(--primary) transition-colors';

export const useTenantOptions = () => {
  const [tenants, setTenants] = useState<TenantOption[]>([]);
  useEffect(() => {
    tokenApi.tenants().then(setTenants).catch(() => setTenants([]));
  }, []);
  return tenants;
};

/** Debounce a fast-changing value such as a search box. */
export const useDebounced = <T,>(value: T, delay = 350) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
};
